<template>
  <div class="event">
    <div class="pay">
      <Header :name="$t('payment.services.' + $route.params.payment)" :min="_.get(providerInfo, 'min_pay', '')" :max="_.get(providerInfo, 'max_pay', '')"/>
      <form v-show="!isMobile || isMobile && !bankModal" class="app-pay-form" @submit.prevent="withdrawal">
          <div class="col">
            <div class="inline-form">
              <button type="button" class="button secondary block" @click="bankModal = true">Banka Hesaplarım</button>
            </div>
          </div>
          <div class="col">
            <div class="inline-form">
              <label>Banka Hesapları</label>
              <select v-model="form.bank_id">
                  <option :value="null" disabled>Seçiniz</option>
                  <option v-for="(in_bank,key) in banks" :key="key" :value="in_bank.id">{{ in_bank.name }}</option>
              </select>
            </div>
          </div>
          <div class="col">
            <div class="inline-form">
              <label>Tutar</label>
              <input :type="isMobile ? 'tel' : 'number'" placeholder="Çekim tutarınızı yazınız" v-model="form.amount">
            </div>
          </div>
          <div class="col">
            <div class="inline-form">
              <label>Açıklama</label>
              <input type="text" placeholder="Ek notunuz var ise yazınız" v-model="form.note">
            </div>
          </div>
					<div class="col" v-if="check_checkbox">
						<div class="inline-form">
							<label>Kabul ediyorum</label>
							<input type="checkbox" checked='checked' v-model="form.accept_rule"/>
						</div>
					</div>
          <div class="col">
            <ButtonLoader class="primary block" :loader="btnLoading" :text="'Para Çek'" />
          </div>
      </form>
      <div class="addbank-modal">
        <Modal @modalStatus="bankModal = $event" :isVisible="bankModal">
        <template slot="content">
          <h4>{{ create ? 'Banka Hesabi Ekleyin' : 'Banka Hesabı Düzenle' }}</h4>
          <form>
            <div class="col">
              <div class="inline-form">
                <label>Banka Hesapları</label>
                <select v-model="bankForm.bank_id" :disabled="!create">
                  <option :value="null" disabled>Seçiniz</option>
                  <option v-for="(bank,key) in addBanks" :key="key" :value="bank.id">{{ bank.name }}</option>
                </select>
              </div>
            </div>
            <div class="col">
              <div class="inline-form">
                <label>Hesap Numarası</label>
                <input type="text" v-model="bankForm.account_number" placeholder="Hesap Numarası">
              </div>
            </div>
            <div class="col">
              <div class="inline-form">
                <label>Şube Kodu</label>
                <input type="text" v-model="bankForm.branch_code" placeholder="Şube Kodu">
              </div>
            </div>
            <div class="col">
              <div class="row" style="width:100%">
                <div class="col" style="width:36%">
                  <div class="inline-form">
                    <label>Ülke Kodu</label>
                    <select v-model="bankForm.country_code">
                      <option :value="null">Seçiniz</option>
                      <option v-for="(item,key) in countries" :key="key" :value="item.code">{{ item.code }}</option>
                    </select>
                  </div>
                </div>
                <div class="col">
                  <div class="inline-form">
                    <label>Iban</label>
                    <input type="text" v-model="bankForm.iban" placeholder="Iban">
                  </div>
                </div>
              </div>
            </div>
            <div class="col">
              <button type="button" class="button default block" v-if="!create" style="margin:0 2px" @click="deleteBank(bankForm.id)">Hesabı Sil</button>
              <ButtonLoader :style="create ? '' : 'margin:0 2px'" @click.native="create ? sendBank() : editBank()" class="primary block" :type="'button'" :loader="editBtnLoading" :text="create ? 'Hesabı Oluştur' : 'Hesabı Düzenle'" />

            </div>
          </form>
          <slot v-if="_.isEmpty(!banks)">
            <h4>Hesap Düzenle</h4>
            <div class="col">
              <button class="button" type="button" style="margin-right:5px" @click="create = false; editForm(bank)" v-for="(bank, index) in banks" :key="index" 
              :class="bankForm.bank_id == bank.bank_id && !create ? 'primary' : 'secondary'" 
              :bank-id="bank.id"><b>{{ bank.name }} Hesabım</b></button>
            </div>
          </slot>
        </template>
      </Modal>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from "vuex";
  import Header from '../../../../components/User/Pay/Header'
  import Form from '../../../../components/User/Pay/Form'

  export default{
    props: ['providerInfo'],
    data(){
      return{
        form:{
          bank_id:null,
          amount: null,
          accept_rule: false,
        },
        bankForm:{
          id: null,
          bank_id:null,
          iban:null,
          account_number:null,
          branch_code:null,
          country_code: 'TR',
        },
        loading: false,
        btnLoading: false,
        banks: null,
        bank: null,
        create: true,
        min_pay: null,
        max_pay: null,
        addBanks: null,
        bankModal: null,
        editBtnLoading:false,
        check_checkbox: false,
      }
    },
    computed: {
      ...mapState("countries", ["countries"])
    },
    created(){
      this.fetchData();
    },
    methods:{
      fetchData() {
        axios.get('/user/wallet/withdrawal/bank/list')
        .then((response) => {
          this.banks 	  = response.data.user_banks;
          this.addBanks 	  = response.data.banks_list;
          if(_.isEmpty(this.banks)){
            this.bankModal = true;
          }
        })
        .catch((err) => {
        })
      },
      withdrawal(){
  		  this.btnLoading = true;
        axios.post('/user/wallet/withdrawal/bank/create', this.form)
        .then((response) => {
          if (response.data.status) {
            this.$store.dispatch('wallet/setToPending', true);
            this.$store.dispatch('alert/message', { type: 'success', msg: response.data.message })
          }
        })
        .catch((err) => {
          if (err.response.data.check_checkbox){
            this.check_checkbox = true;
          }
        })
        .finally(() => {
          this.btnLoading = false;
        });
      },
      sendBank(){
          this.editBtnLoading = true;
          axios.post('/user/wallet/bank/create', this.bankForm)
          .then((response) => {
            if (response.data.status) {
              this.emptyForm();
              this.$store.dispatch('alert/message', { type: 'success', msg: response.data.message });
              this.bankModal = false;
              this.fetchData();
            }
          }).catch((err) => {
          })
          .finally(() => {
            this.editBtnLoading = false;
          });
      },
      editBank(){
          this.editBtnLoading = true;
          axios.patch('/user/wallet/bank/update/' + this.bankForm.id, this.bankForm)
          .then((response) => {
            if (response.data.status) {
              this.emptyForm();
              this.$store.dispatch('alert/message', { type: 'success', msg: response.data.message });
              this.bankModal = false;
              this.fetchData();
            }
          }).catch(() => {
          })
          .finally(() => {
            this.editBtnLoading = false;
          });
      },
      deleteBank(bank_id){
          axios.delete('/user/wallet/bank/delete/' + bank_id)
          .then((response) => {
            if (response.data.status) {
              this.emptyForm();
              this.$store.dispatch('alert/message', { type: 'success', msg: response.data.message });
              this.bankModal = false;
              this.fetchData();
            }
          }).catch(() => {
          })
          .finally(() => {
          });
      },
      editForm(bank){
				this.bankForm.id 		= parseInt(bank.id);
				this.bankForm.bank_id 		= parseInt(bank.bank_id);
				this.bankForm.iban 			= bank.iban;
				this.bankForm.account_number = bank.account_number;
				this.bankForm.branch_code 	= bank.branch_code;
				this.bankForm.country_code 	= bank.country;
      },
      emptyForm(){
				this.bankForm.id 		= null;
				this.bankForm.bank_id 		= null;
				this.bankForm.iban 			= null;
				this.bankForm.account_number = null;
				this.bankForm.branch_code 	= null;
        this.bankForm.country_code 	= 'TR';
      },
    },
    components:{
      Header,
      Form
    }
  }

</script>
